import { Button, Flex, MultiSort, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { forwardRef } from "react";

/**
 * Fields structure for holder and position fields
 */
const Fields = {
  holderFields: [],
  positionFields: []
};

export const FieldMultiSelection = forwardRef((props, ref) => {
  const {
    dataTestIdPrefix,
    hasFilter,
    headerMap,
    onToggleAll,
    onChange,
    filteredItems,
    items,
    onSelectionChange,
    disabledIds
  } = props;

  return (
    <MultiSort
      dataTestIdPrefix={dataTestIdPrefix}
      multiSelect
      items={filteredItems}
      setItems={onChange}
      onSelectionChange={onSelectionChange}
      handleRef={ref}
      disabledIds={disabledIds}
      renderContainerHeader={headerProps => {
        let headerLabel = headerMap?.[headerProps.id] || headerProps.id;

        return (
          <Flex
            dataTestId={headerProps.dataTestId}
            className="oc-multisort-header"
            direction="column"
            gap="8px"
            padding="8px 6px"
          >
            <Flex gap="4px" justifyContent="space-between" alignContent="baseline">
              <Flex gap="4px">
                <Text modifier="medium">{headerLabel}</Text>
                <FieldContainerCount
                  hasFilter={hasFilter}
                  filteredCount={filteredItems[headerProps.id]?.length || 0}
                  unfilteredCount={items[headerProps.id]?.length || 0}
                />
              </Flex>
              <Button
                dataTestId={`${dataTestIdPrefix}-${headerProps.id}-toggle-all`}
                modifier="secondary"
                size="small"
                onClick={onToggleAll(headerProps.id)}
              >
                {appstr("Select All")}
              </Button>
            </Flex>
          </Flex>
        );
      }}
    />
  );
});

const FieldContainerCount = props => {
  const { hasFilter, filteredCount, unfilteredCount } = props;

  return (
    <Text>({hasFilter ? `${filteredCount} / ${unfilteredCount}` : `${unfilteredCount}`})</Text>
  );
};
